/*
 * Hand the person a file made in the page: a Blob, saved under `filename`
 * through a temporary link. Used by the analysis exports and charts, the
 * audit-ledger export and the experiment record.
 */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/* Text (a CSV, a Markdown page, pretty-printed JSON) as a file of `type`. */
export function saveText(text, filename, type) {
  saveBlob(new Blob([text], { type }), filename);
}
